// 商品カード用: SKU別の平均評価と件数から星と件数を描画
// データは軽量集計マップ（product-reviews-summary.js）を優先し、
// 無い場合のみフルデータ（product-reviews-data.js）から集計するフォールバック
(function () {
  function init() {
    var ratingMap = window.__smoReviewsSummary || null;

    if (!ratingMap) {
      var allReviews = window.__smoReviews || [];
      if (!allReviews.length) return;
      // SKU → { count, sum, avg } のマップを作成
      ratingMap = {};
      allReviews.forEach(function (r) {
        if (!r.sku) return;
        var key = String(r.sku).toUpperCase();
        if (!ratingMap[key]) {
          ratingMap[key] = { count: 0, sum: 0 };
        }
        ratingMap[key].count += 1;
        ratingMap[key].sum += Number(r.rating) || 0;
      });
      Object.keys(ratingMap).forEach(function (k) {
        ratingMap[k].avg = ratingMap[k].sum / ratingMap[k].count;
      });
    }

    // [data-card-sku] を持つ商品カードを走査
    var cards = document.querySelectorAll('[data-card-sku]');
    cards.forEach(function (el) {
      var sku = (el.getAttribute('data-card-sku') || '').toUpperCase();
      if (!sku) return;
      var data = ratingMap[sku];
      if (!data) return;

      var avg = data.avg;
      var count = data.count;
      var rounded = Math.round(avg * 10) / 10;

      // 星アイコン（5つ）— 半星対応
      var starsHtml = '';
      var fullStars = Math.floor(avg);
      var hasHalf = avg - fullStars >= 0.25 && avg - fullStars < 0.75;
      var hasUpper = avg - fullStars >= 0.75;
      for (var i = 1; i <= 5; i++) {
        if (i <= fullStars || (i === fullStars + 1 && hasUpper)) {
          starsHtml += '<span class="card-rating__star card-rating__star--full">★</span>';
        } else if (i === fullStars + 1 && hasHalf) {
          starsHtml += '<span class="card-rating__star card-rating__star--half">★</span>';
        } else {
          starsHtml += '<span class="card-rating__star card-rating__star--empty">★</span>';
        }
      }

      el.innerHTML =
        '<span class="card-rating__stars" aria-hidden="true">' + starsHtml + '</span>' +
        '<span class="card-rating__score">' + rounded.toFixed(1) + '</span>' +
        '<span class="card-rating__count">(' + count + ')</span>';
      el.setAttribute('aria-label', '評価 ' + rounded.toFixed(1) + ' / 5、' + count + '件のレビュー');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
